import cjsModule from './index.js';

export const AsymmetricMatcher = cjsModule.AsymmetricMatcher;
export const JestAssertionError = cjsModule.JestAssertionError;
export const expect = cjsModule.expect;
export default cjsModule.default;
